<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <div>
        <FinalSubmitCheckedComponent
                v-if="ckeckedFinalSubmitCheckedComponent()"/>
        <FinalSubmitRedeemComponent
                v-if="checkedFinalSubmitRedeemComponent()"/>

        <v-card  v-if="!ckeckedFinalSubmitCheckedComponent() && !checkedFinalSubmitRedeemComponent()">
            <v-list subheader two-line>
                <v-subheader class="justify-center red--text">
                    Δεν έχετε επιλέξει κάποιο μάθημα
                </v-subheader>
            </v-list>
        </v-card>
    </div>

    <!--<v-list two-line subheader grow>-->

        <!--<v-list-tile-->
                <!--v-if="Object.keys($store.getters.checkedBooks).length > 0"-->
                <!--v-for="bookItem in $store.getters.checkedBooks"-->
                <!--:key="bookItem.books.books[0].book.id"-->
                <!--avatar-->
                <!--@click="openDialog(bookItem.books.books[0].book)"-->
        <!--&gt;-->
            <!--<v-list-tile-avatar size="36px">-->
                <!--<v-icon class="primary white&#45;&#45;text" small>library_books</v-icon>-->
            <!--</v-list-tile-avatar>-->

            <!--<v-list-tile-content>-->
                <!--<v-list-tile-title>{{ bookItem.books.books[0].book.title }}</v-list-tile-title>-->
                <!--<v-list-tile-sub-title>[{{ bookItem.books.books[0].book.id }}] - ISDN: {{ bookItem.books.books[0].book.isbn }}</v-list-tile-sub-title>-->
            <!--</v-list-tile-content>-->

            <!--<v-list-tile-action>-->
                <!--<ToolTipComponent :bookId="bookItem.books.books[0].book.id "/>-->
            <!--</v-list-tile-action>-->
        <!--</v-list-tile>-->



        <!--<v-list-tile-->
                <!--v-if="Object.keys($store.getters.redeemPoints).length > 0"-->
                <!--v-for="bookItem in $store.getters.redeemPoints"-->
                <!--:key="bookItem.books.books[0].book.id"-->
                <!--avatar-->
                <!--@click="openDialog(bookItem.books.books[0].book)">-->
            <!--<v-list-tile-avatar size="36px">-->
                <!--<v-icon class="primary white&#45;&#45;text" small>library_books</v-icon>-->
            <!--</v-list-tile-avatar>-->

            <!--<v-list-tile-content>-->
                <!--<v-list-tile-title>{{ bookItem.books.books[0].book.title }}</v-list-tile-title>-->
                <!--<v-list-tile-sub-title>[{{ bookItem.books.books[0].book.id }}] - ISDN: {{ bookItem.books.books[0].book.isbn }}</v-list-tile-sub-title>-->
            <!--</v-list-tile-content>-->

            <!--<v-list-tile-action>-->
                <!--<ToolTipComponent :bookId="bookItem.books.books[0].book.id "/>-->
            <!--</v-list-tile-action>-->
        <!--</v-list-tile>-->
        <!--&lt;!&ndash;<v-subheader class="text-xs-center" v-else>Κανένα βιβλίο</v-subheader>&ndash;&gt;-->
    <!--</v-list>-->
</template>

<script>

    import FinalSubmitCheckedComponent from "./FinalSubmitCheckedComponent";
    import FinalSubmitRedeemComponent from "./FinalSubmitRedeemComponent";

    export default {
        name: "ReviewStatementBooksComponent",
        components: {FinalSubmitCheckedComponent , FinalSubmitRedeemComponent},
        data () {
            return {

            }
        },
        methods:{
            ckeckedFinalSubmitCheckedComponent() {
                return this.$store.getters.booksFromCheckedByDistPoint.length > 0 || this.$store.getters.booksFromCheckedByCourrier.length > 0;
            },
            checkedFinalSubmitRedeemComponent() {
                return this.$store.getters.booksFromRedeemByDistPoint.length > 0 || this.$store.getters.booksFromRedeemByCourrier.length > 0;
            }
        }
    }
</script>

<style scoped>

</style>